import { render } from "./HomeCategories.vue?vue&type=template&id=ea0def4e&lang=pug"
import script from "./HomeCategories.vue?vue&type=script&lang=js"
export * from "./HomeCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__